import { Application, MAX_TICKET_RECORDS } from 'models'
import { ApplicationsServiceV4 } from 'services/v4/applications-v4.service'
import { discardAbandonedApplication } from 'ui/pages/settings/integrations/applications/abandonedSetup'

export const OUTBOUND_INTEGRATIONS_PATH = '/settings/integrations/ticketing-systems'

export const TICKET_NO_PERMISSION_MESSAGE = 'Your role does not allow creating tickets.'

export const TICKET_LIMIT_MESSAGE = `Select up to ${MAX_TICKET_RECORDS} entities to create a ticket.`

export const TICKET_RECORDS_NOT_LOADED_MESSAGE = 'Some selected records are no longer loaded. Select them again.'

const JIRA_APPLICATION_SLUG = 'atlassian_jira'

/* The tenant's connected Jira instances, the only outbound service tickets can be created in for now.
 * The filter route may leave `manifest` out, so instances are matched on the Jira manifest's id. */
export const listTicketingApplications = async (): Promise<Application[]> => {
  await discardAbandonedApplication()
  const [manifest, applications] = await Promise.all([
    ApplicationsServiceV4.getManifest(JIRA_APPLICATION_SLUG),
    ApplicationsServiceV4.listLiveApplications()
  ])
  return applications.filter(
    (a) =>
      ((manifest && a.manifest_id === manifest.id) || a.manifest?.slug === JIRA_APPLICATION_SLUG) &&
      (!a.connection || a.connection.status === 'CONNECTED')
  )
}
